import lodash from 'lodash';
import {
    put, takeEvery, select,
} from 'redux-saga/effects';
import { message } from 'antd';
import moment from 'moment';

import {
    getLeads,
} from '../../requests/get_leads_request';
import { getCountyList } from '../../requests/get_county_list_request';
import { getCountyListSuccess } from '../actions/get_county_list.actions';
import {
    getLeadsSuccess,
    getLeadsFailure,
    countLeadsSuccess,
    setLeadManageLoading,
} from '../actions/get_leads.actions';
import { GET_LEADS_LEAD_MANAGE } from '../constants/get_leads.constants';
import { getAllowedDivisionIds, buildFiltersForLeadsReq, clearingFiltersForLeadReq } from '../../utils/buildFiltersForLeadsReq';
import buildAsyncFiltersForLeads from '../../../shared/sagas/buildAsyncFiltersForLeads.saga';
import { checkIsLeadManageDeliveryRequested } from '../../utils/index';

window.moment = moment;

function* getLeadsRequest() {
    const store = yield select();
    const divisionsIds = getAllowedDivisionIds(store);

    yield put(setLeadManageLoading(true));

    const filters_lead_manage = lodash.merge({}, store.Leads.Leads_manage.filters);
    const isAutoPriced = filters_lead_manage.served_live_price ? filters_lead_manage.served_live_price : false;
    const pagination_lead_manage = lodash.merge({}, store.Leads.Leads_manage.pagination);

    const filtersForLeadsReq = buildFiltersForLeadsReq(filters_lead_manage, divisionsIds);
    const where = yield buildAsyncFiltersForLeads(filtersForLeadsReq, true);

    // if nothing found by search with customer phone or bike vrm, brand or/and model, then return 0 leads
    if (where.ref_lead_customer === null || where.ref_bike_lead === null) {
        // yield put(countLeadsSuccess(0));
        yield put(getLeadsSuccess([]));
    } else {
        /*
            {
                "5beabfe7f25bf5f49685abfb": 'Pending',
                '5c349213b01ff686c64b1dd4': 'Priced',
                '5beabfe7f25bf5f49685abfc': 'Price Given',
                "5bf2b498f83650911c3e3e80": 'In Progress'
            }
        */

        // delete not needed fields for get leads request
        const cleanFilters = clearingFiltersForLeadReq(where);
        const { sortField, sortDirection } = filters_lead_manage;

        const leads = yield getLeads(cleanFilters, pagination_lead_manage, isAutoPriced, sortField, sortDirection);

        if (checkIsLeadManageDeliveryRequested()) {
            const countyList = yield getCountyList();

            if (countyList.result) {
                yield put(getCountyListSuccess(countyList.options));
            }
        }

        if (leads.result) {
            yield put(getLeadsSuccess(leads.options));
        } else {
            if (leads.error && leads.error.kind === 'number') {
                message.error('Value must be number');
            } else {
                message.error(leads.error.message);
            }
            yield put(countLeadsSuccess(0));
            yield put(getLeadsFailure(leads.error));
        }
    }

    // saving where condition in redux and closing loading
    // yield put(setLeadManageNewKey({ data: { where, 'pagination.page': 0 } }));
    yield put(setLeadManageLoading(false));
}

export default function* getLeadsSaga() {
    yield takeEvery(GET_LEADS_LEAD_MANAGE, getLeadsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/sagas/get_leads.saga.js